import React from 'react';
import { useSelector } from 'react-redux';
export function Price({ amount, className }) {
    const priceSuffix = useSelector((state) => state.ui.priceSuffix);
    return (React.createElement("span", { className: className },
        amount && Number.isInteger(amount) ? amount : amount.toFixed(2),
        " kr ",
        React.createElement("small", null, priceSuffix)));
}
